module.exports = __webpack_public_path__ + "img/crying.2cad2812.png";